export default {
  computed: {
    modulesSubSettings() {
      return {
        BILLINGS: [
          {
            name: 'billings_legalization_enabled',
            titlePath: 'admin.billingsLegalizationEnabled',
            subtitlePath: 'admin.billingsLegalizationEnabledSubtitle',
          },
          {
            name: 'billings_water_dissolution_dma_zone_enabled',
            titlePath: 'admin.billingsWaterDissolutionEnabled',
            subtitlePath: 'admin.billingsWaterDissolutionEnabledSubtitle',
          },
          {
            name: 'billings_water_dissolution_watermeters_enabled',
            titlePath: 'admin.billingsWaterDissolutionWatermetersEnabled',
            subtitlePath: 'admin.billingsWaterDissolutionWatermetersEnabledSubtitle',
          },
          {
            name: 'billings_anomaly_detection_enabled',
            titlePath: 'admin.billingsAnomalyDetectionEnabled',
            subtitlePath: 'admin.billingsAnomalyDetectionEnabledSubtitle',
          },
        ],
        FAILURES: [
          {
            name: 'failures_cutoff_enabled',
            titlePath: 'admin.failuresCutoffEnabled',
            subtitlePath: 'admin.failuresCutoffEnabledSubtitle',
          },
          {
            name: 'failures_dispatcher_enabled',
            titlePath: 'admin.failuresDispatchedEnabled',
            subtitlePath: 'admin.failuresDispatchedEnabledSubtitle',
          },
        ],
        LOCATION_LAB: [
          {
            name: 'location_lab_edit_enabled',
            titlePath: 'admin.locationLabEnlargement',
            subtitlePath: 'admin.locationLabEnlargementSubtitle',
          },
        ],
        WATER_MODELING: [
          {
            name: 'epanet_calibration_data_enabled',
            titlePath: 'admin.calibrationFilesGeneration',
            subtitlePath: 'admin.calibrationFilesGenerationSubtitle',
          },
          {
            name: 'epanet_run_analysis_enabled',
            titlePath: 'admin.epanetModelAnalysis',
            subtitlePath: 'admin.epanetModelAnalysisSubtitle',
          },
        ],
        SEWER_ANALYSIS: [
          {
            name: 'sewer_congestion_enabled',
            titlePath: 'admin.sewerCongestion',
            subtitlePath: 'admin.sewerCongestionSubtitle',
          },
        ],
        WATER_BALANCE_MODULE: [
          {
            name: 'water_balance_balance_enabled',
            titlePath: 'admin.waterBalanceZone',
            subtitlePath: 'admin.waterBalanceZoneSubtitle',
          },
          {
            name: 'water_balance_dma_enabled',
            titlePath: 'admin.waterBalanceDma',
            subtitlePath: 'admin.waterBalanceDmaSubtitle',
          },
          {
            name: 'water_balance_iwa_enabled',
            titlePath: 'admin.waterBalanceIwa',
            subtitlePath: 'admin.waterBalanceIwaSubtitle',
            value: true,
          },
        ],
      };
    },
    subSettingsModules() {
      return Object.keys(this.modulesSubSettings);
    },
  },
};
